export enum ReferenceKey {
  NameTitle = 'NameTitle',
  IDType = 'IDType',
  Religion = 'Religion',
  ResidentStatus = 'ResidentStatus',
  Education = 'Education',
  EmploymentType = 'EmploymentType',
  Race = 'Race',
  MaritalStatus = 'MaritalStatus',
  Gender = 'Gender',
  OccupationSectorIndustry = 'OccupationSectorIndustry',
  GCIFOccupation = 'GCIFOccupation',
  ContactType = 'ContactType',
  AddressType = 'AddressType',
  State = 'State',
  LoanType = 'LoanType',
  RiskAppetite = 'RiskAppetite',
  FinancingLoanType = 'FinancingLoanType',
  Relationship = 'Relationship',
  ApplicationType = 'ApplicationType',
  DistributionChannel = 'DistributionChannel',
  PaymentSource = 'PaymentSource',
  ClientType = 'ClientType',
  Language = 'Language',
  MonthlyIncome = 'MonthlyIncome',
  DeductibleLimit = 'DeductibleLimit',
  UWStatus = 'UWStatus',
  Bank = 'Bank',
  PaymentMode = 'PaymentMode',
  PurposeOfTransaction = 'PurposeOfTransaction',
  OccupationalClass = 'OccupationalClass',
  Country = 'Country',
  Nationality = 'Nationality',
  PostcodeCityState = 'PostcodeCityState',
  SourceFund = 'SourceFund',
  SourceWealth = 'SourceWealth',
}
